import { put } from 'redux-saga/effects';
import { fetchAlertsFail, fetchAlertsSuccess } from './actions';
import { getAlerts } from './backend';
import { makeErrorPayload } from '../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../shared/toast/redux/actions';
import { pagingParams } from '../../../../../shared/helpers/url-params.helper';

export function* fetchAlertsSaga(action) {
    try {
        const {
            ruleType,
            alertLevel,
            dismissType,
            dismissed,
            brandId,
            jurisdictionCode,
            pagination,
            sort,
            username,
            ruleCategory,
            dismissedBy
        } = action.payload;

        const response = yield getAlerts({
            dismissed,
            brandId,
            jurisdiction: jurisdictionCode,
            ...pagingParams(pagination),
            ...sort,
            username,
            ruleType,
            alertLevel,
            dismissType,
            ruleCategory,
            dismissedBy
        });
        yield put(fetchAlertsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchAlertsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
